export enum TipoFichaEvento {
  QUANTIDADE = 'QUANTIDADE',
  VENDA = 'VENDA',
}
